class GeoCodingResult {
  /**
   * @param {Object} data
   * @param {number | undefined} data.cityId
   * @param {number | undefined} data.regionId
   * @param {number | undefined} data.countryId
   * @param {GeoPoint} data.geoPoint
   */
  constructor({cityId, regionId, countryId, geoPoint}) {
    /** @type {number} */
    this.cityId = cityId;
    /** @type {number} */
    this.regionId = regionId;
    /** @type {number} */
    this.countryId = countryId;
    /** @type {GeoPoint} */
    this.geoPoint = geoPoint;
  }
}

export default GeoCodingResult;